import { render, staticRenderFns } from "./Stickers.vue?vue&type=template&id=f2a07830&scoped=true&"
import script from "./Stickers.vue?vue&type=script&lang=js&"
export * from "./Stickers.vue?vue&type=script&lang=js&"
import style0 from "./Stickers.vue?vue&type=style&index=0&id=f2a07830&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a07830",
  null
  
)

export default component.exports